/**
 * 路由 meta.title / dividerLabel / parentGroup 等中文 → 英文（与 routeConfig 闭环中文一致，仅展示层切换）
 */
export const ZH_EN_MAP = {
  AI: 'AI',
  'AI 助手': 'AI Assistant',
  AI助手: 'AI Assistant',
  AI智能对话: 'AI Chat',
  AI智能报表: 'AI Reports',
  代收款管理: 'Collection Management',
  落位展示: 'Location Display',
  落位: 'Location',
  车辆管理: 'Vehicle Management',
  停车系统: 'Parking System',
  充电卡流水: 'Charging Card Transactions',
  充电桩总览: 'Charging Overview',
  其他智能设备: 'Other Smart Devices',
  分摊账单: 'Allocation Bills',
  分项计量: 'Sub-metering',
  分项计量设置: 'Sub-metering Settings',
  区域: 'Areas',
  区域可视化: 'Area Visualization',
  区域管理: 'Area Management',
  区域配置: 'Area Configuration',
  后台: 'Admin',
  后台模块: 'Admin Modules',
  定时任务: 'Scheduled Tasks',
  对公充值: 'Corporate Recharge',
  应用: 'Applications',
  应用管理: 'Application Management',
  微信充值: 'WeChat Recharge',
  成本管理: 'Cost Management',
  手动充值: 'Manual Recharge',
  手动账单: 'Manual Bills',
  抄表记录: 'Meter Reading Records',
  '数字物宇-物联中台API文档': 'API Documentation',
  智能对话: 'Smart Dialogue',
  服务费方案: 'Service Fee Plans',
  权限: 'Permissions',
  权限信息: 'Permission Info',
  标签管理: 'Tag Management',
  水空调: 'Water-cooled AC',
  水费方案: 'Water Tariff Plans',
  浮动电价: 'Floating Tariffs',
  照明: 'Lighting',
  照明控制: 'Lighting Control',
  照明管理: 'Lighting Management',
  环境监测: 'Environmental Monitoring',
  生活水: 'Domestic Water',
  用水桑基图: 'Water Sankey',
  用电桑基图: 'Electricity Sankey',
  用电分项计量: 'Elec Sub-meter',
  电力分析: 'Power Insight',
  损耗分析: 'Loss Analysis',
  用电拓扑: 'Power Topology',
  回路监测: 'Circuit Monitoring',
  监测: 'Monitoring',
  用能: 'Energy Usage',
  用能账单: 'Energy Bills',
  电表用电: 'Meter Electricity',
  电费成本管理: 'Electricity Cost Management',
  电费方案: 'Electricity Tariff Plans',
  电费核查联: 'Electricity Audit Link',
  电费核查联解析: 'Electricity Audit Parsing',
  电费调价记录: 'Tariff Adjustment Log',
  直饮水: 'Drinking Water',
  票务管理: 'Ticketing',
  租户: 'Tenants',
  租户卡片: 'Tenant Cards',
  租户层级: 'Tenant Hierarchy',
  租户开票: 'Tenant Invoicing',
  租户流水: 'Tenant Transactions',
  租户用水: 'Tenant Water',
  租户用电: 'Tenant Electricity',
  租户用能报表: 'Tenant Energy',
  租户看板: 'Tenant Dashboard',
  租户管理: 'Tenant Management',
  租户计费方案: 'Tenant Billing Plans',
  租户详情: 'Tenant Details',
  租户账单: 'Tenant Bills',
  租户退款: 'Tenant Refunds',
  空调控制: 'HVAC Control',
  空调用电: 'HVAC Electricity',
  管理: 'Management',
  编码管理: 'Code Management',
  群组控制: 'Group Control',
  能耗概览: 'Energy Overview',
  给排水: 'Water Supply & Drainage',
  历史数据: 'Historical Data',
  菜单管理: 'Menu Management',
  落位图: 'Floor Plan',
  角色管理: 'Role Management',
  计费: 'Billing',
  订单管理: 'Order Management',
  记录查询: 'Record Search',
  设备: 'Devices',
  设备信息: 'Device Info',
  设备用水: 'Device Water',
  设备用能报表: 'Device Energy',
  财务: 'Finance',
  账单: 'Bills',
  账单管理: 'Bill Management',
  账单统计: 'Bill Statistics',
  账号: 'Accounts',
  车位管理: 'Parking Space Management',
  运行时间记录: 'Runtime Records',
  配电图: 'Single-line Diagram',
  集中控制: 'Centralized Control',
  首页: 'Dashboard',
  空调智控: 'HVAC Intelligence',
  充电服务: 'Charging Services',
  停车收费: 'Parking Payment',
  智慧照明: 'Smart Lighting',
  控制台: 'Console',
  管理后台首页: 'Admin Home',
  管理后台: 'Administration',
  数据监控与分析: 'Monitoring & Analytics',
  系统管理与配置: 'System Management',
  未命名页面: 'Untitled',
  看板: 'Dashboard',
  数据看板: 'Dashboard',
  管理后台大屏: 'Admin Console Screen'
}
